import * as React from 'react';
import MultiSelectModal from '../../../misc/components/queryTable/MultiSelectModal';
import {
    Query,
    QueryCondition,
    QueryFilter,
    QueryOrderDirection,
    Site,
    SpirometrySessionMetadata
} from "../../../misc/api/apiTypes";
import { useWebPortalLegacyClient } from '../../../misc/api/WebPortalTokenClient';

const SiteIdFilterQueryCondition = QueryCondition.Equal;
export const SiteIdHeader = "Site ID";

interface SiteFilterProps {
    filterMember: string;
    onClose: (member: string, condition: QueryCondition, values: string[]) => void;
    query: Query<SpirometrySessionMetadata>;
}

const SiteIdFilterModal = ({ filterMember, onClose, query }: SiteFilterProps): JSX.Element => {

    const GetQueryFilter = (query: Query<SpirometrySessionMetadata>): QueryFilter => {
        return query.Filters.find(filter => filter.Member === filterMember && filter.Condition === SiteIdFilterQueryCondition);
    }

    const queryFilter = GetQueryFilter(query);

    const [values, setValues] = React.useState<any[]>(queryFilter ? queryFilter.Values : []);

    const [allSites, setAllSites] = React.useState<Site[]>(null);
    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        legacyClient.getSites({
            Order: {
                Member: "SiteNumber",
                Direction: QueryOrderDirection.Ascending,
            },
        }).then(sitesQ => {
            setAllSites(sitesQ.Data);
        });
    }, []);

    return (<MultiSelectModal header='Site ID Filter'
        isLoading={!allSites}
        show={true}
        options={allSites}
        valueKey="SiteNumber"
        labelKey="SiteNumber"
        values={values}
        onChange={(updatedValues) => setValues(updatedValues.map(v => v.SiteNumber))}
        onClose={() => onClose(filterMember, SiteIdFilterQueryCondition, values)}
        onClear={() => {
            onClose(filterMember, SiteIdFilterQueryCondition, []);
        }}
    />)
}

export default SiteIdFilterModal;
